// ============================================================================
// UI Helper Functions
// Extracted from AppointmentForm.js — pure display utilities, no state.
// ============================================================================

// ---------------------------------------------------------------------------
// Provider classification
// ---------------------------------------------------------------------------

export function getProgramType(providerName) {
  if (providerName.includes('PA-C') || providerName.includes('PA')) return 'Medical';
  if (providerName.includes('MD') || providerName.includes('DO')) return 'Other';
  if (providerName.includes('PMHNP') || providerName.includes('PMHMP') || providerName.includes('NP')) return 'Psychiatric';
  if (providerName.includes('LCSW') || providerName.includes('LPC') || providerName.includes('LMFT')) return 'Therapy';
  if (providerName.includes('RN') || providerName.includes('BSN')) return 'Nursing';
  return 'Other';
}

export function getProgramColor(programType) {
  switch (programType) {
    case 'Medical':    return 'bg-blue-100 text-blue-800';
    case 'Therapy':    return 'bg-green-100 text-green-800';
    case 'Psychiatric': return 'bg-purple-100 text-purple-800';
    case 'Nursing':    return 'bg-orange-100 text-orange-800';
    default:           return 'bg-gray-100 text-gray-800';
  }
}

// ---------------------------------------------------------------------------
// Day-of-week labels
// ---------------------------------------------------------------------------

export function mapDaysToNames(dayString) {
  const dayMap = {
    '1': 'Monday', '2': 'Tuesday', '3': 'Wednesday',
    '4': 'Thursday', '5': 'Friday', '6': 'Saturday', '7': 'Sunday'
  };
  if (!dayString) return 'No availability';
  return dayString.split(',').map(day => dayMap[day.trim()]).join(', ');
}

// ---------------------------------------------------------------------------
// Time range formatter
// Returns { displayRange: "9:00 AM - 9:40 AM", preferredTime: originalString }
// ---------------------------------------------------------------------------

export function formatTimeRange(timeString, duration = 40) {
  const [time, period] = timeString.split(' ');
  const [hours, minutes] = time.split(':');
  let hour24 = parseInt(hours);

  if (period === 'PM' && hour24 !== 12) hour24 += 12;
  else if (period === 'AM' && hour24 === 12) hour24 = 0;

  const startTime = new Date();
  startTime.setHours(hour24, parseInt(minutes), 0, 0);
  const endTime = new Date(startTime.getTime() + duration * 60000);

  const fmt = (date) => {
    const h = date.getHours();
    const m = date.getMinutes();
    const p = h >= 12 ? 'PM' : 'AM';
    const dh = h % 12 || 12;
    const dm = m.toString().padStart(2, '0');
    return `${dh}:${dm} ${p}`;
  };

  return {
    displayRange: `${fmt(startTime)} - ${fmt(endTime)}`,
    preferredTime: timeString
  };
}
